import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

import MinisterInfoList from './pages/ministerInfo/MinisterInfoList';
import MinisterInfoDetail from './pages/ministerInfo/MinisterInfoDetail';
import MinisterPageList from './pages/ministerPage/MinisterPageList';
import MinisterPageDetail from './pages/ministerPage/MinisterPageDetail';
import MinisterWriteGuide from './pages/ministerInfo/MinisterWriteGuide';
import MinisterMyInfo from './pages/ministerInfo/MinisterMyInfo';

export default function MinisterRouter() {
  const { pathname } = useLocation();
  // 프로필페이지 상세는 단독 홈페이지처럼 보여주므로 헤더·풋터를 숨긴다
  const hideLayout = pathname.replace(/\/+$/, '') === '/minister/profilepage/detail';

  return (
    <div>
      {!hideLayout && <Header />}
      <Routes>
        <Route path="/" element={<MinisterInfoList/>}/>
        <Route path="/detail" element={<MinisterInfoDetail/>}/>
        {/* 상단 '내 정보 보기' — 본인 이력서·자기소개서·포트폴리오 */}
        <Route path="/my" element={<MinisterMyInfo/>}/>
        {/* 비로그인 사용자가 항목을 눌렀을 때 — 이력서·자기소개서·포트폴리오 작성 안내 */}
        <Route path="/write" element={<MinisterWriteGuide/>}/>
        {/* 프로필페이지 — 목록·상세 (설정은 마이페이지 > 프로필페이지 관리) */}
        <Route path="/profilepage" element={<MinisterPageList/>}/>
        <Route path="/profilepage/detail" element={<MinisterPageDetail/>}/>
        <Route path="/edit" element={<Navigate to="/mypage/profilepage" replace />}/>
      </Routes>
      {!hideLayout && <Footer />}
    </div>
  )
}
